export default __webpack_public_path__ + "static/media/Nyella.25254de9.png";